import React, { useState, useEffect, useRef } from "react";
import { ClipboardList, X, Plus } from "lucide-react";
import graphqlRequest from "../../requestMethod";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import MUIAdditionalSkills from "./pages/MUIAdditionalSkills";
import "./ProfessionalDetailsForm.scss";

const ProfessionalDetailsForm = ({ details, onChange }) => {
  const [skillSetDropdownOpen, setSkillSetDropdownOpen] = useState(false);
  const [newSkill, setNewSkill] = useState("");
  const [showAddSkill, setShowAddSkill] = useState(false);
  const [hospitals, setHospitals] = useState([]);
  const [departments, setDepartment] = useState([]);
  const [departmentTypeId, setDepartmentTypeId] = useState([]);
  const [professions, setProfession] = useState([]);
  const [qualifications, setQualification] = useState([]);
  const [specializations, setSpecialization] = useState([]);
  const [experiences, setExperience] = useState([]);
  const [additionalSkills, setAdditionalSkill] = useState([]);
  const [skillError, setSkillError] = useState("");
const [searchQuery, setSearchQuery] = useState("");
const [creditLimit, setCreditLimit] = useState(0);

  const [detailsData, setDetailsData] = useState({});
  // console.log("experiencesValue", experiences);
  // console.log("onChangeData", onChange);
  // console.log("detailsData2", details);
  let loginData = localStorage.getItem("auth");
  let token = JSON.parse(loginData)?.accessToken;
  const queryClient = useQueryClient();

  console.log("details New>>", details);

  function fetchHospitalDropdownData() {
    const query = `
      query{
        withAuth(token:"${token}"){
          listMiniJobBranches{
            id
            jobLocation {
              hospitalName
              branchName
            }
            creditLimit
            utilizedLimit
             isNewBranch
            creditThresholdPercent
         }
         }
       }
    `;
    graphqlRequest(query).then((response) => {
      // console.log("responseBranch>>", response);
      if (response?.data?.withAuth?.listMiniJobBranches?.length > 0) {
        // console.log(response.data.withAuth.listMiniJobBranches);
        const hospitalOptions =
          response?.data?.withAuth?.listMiniJobBranches?.map((item) => ({
            id: item.id,
            hospitalName: item.jobLocation.hospitalName.trim(), // optional .trim()
            creditLimit: item.creditLimit,
            utilizedLimit: item.utilizedLimit,
            isNewBranch: item.isNewBranch,
            creditThresholdPercent: item.creditThresholdPercent
          }));
          console.log("hospitalOptions", hospitalOptions);

        if (details.hospital) {
          updateDetail("hospital", details.hospital);
        } else {
          setHospitals(hospitalOptions);
        }
      }
    });
  }

  function fetchDepartmentDropDown() {
    // console.log("details.hospital", details.hospital);
    // creditLimit = branch[0].creditLimit;
    // utilizedLimit = branch[0].utilizedLimit;
    // let id = branch[0].id || formData.hospitalFormId;
    // setCreditLimitData(creditLimit);
    // setUtilizedLimitData(utilizedLimit);
    // let isCreditLimitExceeded = creditLimit < utilizedLimit;

    // setLimitExceeded(isCreditLimitExceeded);
    // if (isCreditLimitExceeded) {
    //   setErrorMessage(
    //     "Credit Limit Exceeded, Please pay pending bills to use further!"
    //   );
    //   setOpenErrorSnackbar(true);
    // }
    let query = `
      query{
        withAuth(token:"${token}"){
          listMiniJobDepartments(branch:"${details.hospital}") {
            id
            departmentType{
              id
              name
            }
            branch{
              id
              creditLimit
              utilizedLimit
            }
          }
         }
       }
      `;
    graphqlRequest(query).then((response) => {
      console.log("department-->", response);
      console.log("responseDep", response?.data?.withAuth);
      const departmentOptions =
        response?.data?.withAuth?.listMiniJobDepartments?.map((item) => ({
          id: item.id,
          name: item.departmentType.name.trim(),
          departmentType: item.departmentType.id,
        }));
      console.log("departmentOptions", departmentOptions);
      setDepartmentTypeId(departmentOptions);
      if (response?.data?.withAuth?.listMiniJobDepartments?.length === 1) {
        const singleDept = {
          id: response.data.withAuth.listMiniJobDepartments[0].id,
          name: response.data.withAuth.listMiniJobDepartments[0].departmentType.name.trim(),
          departmentType:
            response.data.withAuth.listMiniJobDepartments[0].departmentType.id,
        };
        // console.log("singleDept", singleDept);
        setDepartmentTypeId([singleDept]);
        setDepartment([singleDept]); // set the only department
        updateDetail("department", singleDept.id);
      } else {
        const departmentOptions =
          response?.data?.withAuth?.listMiniJobDepartments?.map((item) => ({
            id: item.id,
            name: item.departmentType.name.trim(),
            departmentType: item.departmentType.id,
          }));
        console.log("departmentOptions", departmentOptions);
        setDepartmentTypeId(departmentOptions);
        setDepartment(departmentOptions);
      }
    });
  }

  function fetchProfessionsDropDown() {
    let query = `
     query{
       withAuth(token:"${token}"){
         listMiniJobProfessions (branch:"${details.hospital}" department:"${details.department}") {
           id
           name
           postCost
         }
        }
      }
     `;
    graphqlRequest(query).then((response) => {
      // console.log("profession-->", response);
      if (response?.data?.withAuth?.listMiniJobProfessions?.length === 1) {
        const singleProfession = {
          id: response.data.withAuth.listMiniJobProfessions[0].id,
          name: response.data.withAuth.listMiniJobProfessions[0].name.trim(),
        };

        setProfession([singleProfession]);
        updateDetail("profession", singleProfession.id);
      } else {
        const professionOptions =
          response?.data?.withAuth?.listMiniJobProfessions?.map((item) => ({
            id: item.id,
            name: item.name.trim(),
          }));
        setProfession(professionOptions);
      }
    });
  }

  function fetchQualificationDropDown() {
    let query = `
        query{
          withAuth(token:"${token}"){
            listMiniJobQualifications (branch:"${details.hospital}" 
                                      department:"${details.department}"
                                      profession:"${details.profession}"
            ) {
              id
              name
            }
           }
         }
        `;
    graphqlRequest(query).then((response) => {
      // console.log("qualification-->", response);
      if (response?.data?.withAuth?.listMiniJobQualifications?.length === 1) {
        const singleQualification = {
          id: response.data.withAuth.listMiniJobQualifications[0].id,
          name: response.data.withAuth.listMiniJobQualifications[0].name.trim(),
        };
        setQualification([singleQualification]);
        updateDetail("qualification", singleQualification.id);
      } else {
        const qualificationOptions =
          response?.data?.withAuth?.listMiniJobQualifications?.map((item) => ({
            id: item.id,
            name: item.name.trim(),
          }));
        setQualification(qualificationOptions);
      }
    });
  }

  function fetchSpecializationDropDown() {
    let query = `
          query{
            withAuth(token:"${token}"){
              listMiniJobSpecializations (branch:"${details.hospital}" 
                                        department:"${details.department}"
                                        profession:"${details.profession}"
                                        qualification:"${details.qualification}"
              ) {
                id
                name
              }
             }
           }
          `;
    graphqlRequest(query).then((response) => {
      // console.log("specialization-->", response);
      if (response?.data?.withAuth?.listMiniJobSpecializations?.length === 1) {
        const singleSpecialization = {
          id: response.data.withAuth.listMiniJobSpecializations[0].id,
          name: response.data.withAuth.listMiniJobSpecializations[0].name.trim(),
        };
        setSpecialization([singleSpecialization]);
        updateDetail("specialization", singleSpecialization.id);
      } else {
        const specializationOptions =
          response?.data?.withAuth?.listMiniJobSpecializations?.map((item) => ({
            id: item.id,
            name: item.name.trim(),
          }));
        setSpecialization(specializationOptions);
      }
    });
  }
  function fetchExperienceDropDown() {
    let query = `
          query{
            withAuth(token:"${token}"){
              listMiniJobExperiences (branch:"${details.hospital}" 
                                        department:"${details.department}"
                                        profession:"${details.profession}"
                                        qualification:"${details.qualification}"
                                        specialization: "${details.specialization}"
              ) {
                id
                name
              }
             }
           }
          `;
    graphqlRequest(query).then((response) => {
      // console.log("experience-->", response);
      if (response?.data?.withAuth?.listMiniJobExperiences?.length === 1) {
        const singleExperience = {
          id: response.data.withAuth.listMiniJobExperiences[0].id,
          name: response.data.withAuth.listMiniJobExperiences[0].name.trim(),
        };
        //  console.log("singleExperience", singleExperience);
        setExperience([singleExperience]);
        //  updateDetail("experience", singleExperience.id);
        updateDetail("experience", singleExperience.id, [singleExperience]);
      } else {
        const experincesOptions =
          response?.data?.withAuth?.listMiniJobExperiences?.map((item) => ({
            id: item.id,
            name: item.name.trim(),
          }));
        // console.log("experincesOptions", experincesOptions);
        setExperience(experincesOptions);
      }
    });
  }

  function fetchAdditionalSkillDropDown() {
    console.log("departmentTypeId", departmentTypeId);
    console.log("detailsDatas", details);
    console.log("here 1");
    let departmentData = departmentTypeId?.filter((data) => {
      return data?.id?.toString() === details?.department?.toString();
    });

    console.log("departmentData", departmentData);
    console.log("details.profession", details.profession);
    if (
      !departmentData ||
      !departmentData[0]?.departmentType ||
      !details?.profession
    ) {
      console.warn(
        "Missing departmentType or profession, aborting skill fetch."
      );
      return;
    }

    //  console.log("departmentData", departmentData[0]?.departmentType); //65b2420c3fcb01b29a87b24d

    let query = `
      query{
        withAuth(token:"${token}"){
          listMiniJobSkills (departmentType:"${departmentData[0]?.departmentType}" professionalType:"${details?.profession}"
          ) {
            id
            name
          }
         }
       }
      `;
    graphqlRequest(query).then((response) => {
      console.log("skillresp1", response.data.withAuth.listMiniJobSkills);
      const skills = response?.data?.withAuth?.listMiniJobSkills;

      if (skills?.length >= 1) {
        const additionalSkillsOptions = skills.map((item) => ({
          id: item.id,
          name: item.name.trim(),
        }));

        const allSkillIds = additionalSkillsOptions.map((skill) => skill.id);
        console.log("additionalSkillsOptions", additionalSkillsOptions);
        setAdditionalSkill(additionalSkillsOptions);

        if (additionalSkillsOptions) {
          console.log("Auto-selecting all skill IDs:", allSkillIds);
          onChange({ ...details, skillSet: allSkillIds });
        } else {
          console.log("Preserving existing skillSet:", details.skillSet);
          onChange({ ...details, skillSet: details.skillSet });
        }
      } else {
        console.log("Skill list is empty — clearing skillSet.");
        setAdditionalSkill([]); // Optional: clear dropdown options too
        onChange({ ...details, skillSet: [] });
      }
      //  if (response?.data?.withAuth?.listMiniJobSkills?.length >= 1) {
      //    const additionalSkillsOptions =
      //      response?.data?.withAuth?.listMiniJobSkills?.map((item) => ({
      //        id: item.id,
      //        name: item.name.trim(),
      //      }));
      //    // Auto select all skills when fetched
      //    const allSkillIds = additionalSkillsOptions.map((skill) => skill.id);
      //    console.log("allSkillIds", allSkillIds);
      //    console.log("here 2");
      //    if (!details.skillSet || details.skillSet.length === 0) {
      //      console.log("Auto-selecting all skill IDs:", allSkillIds);
      //      onChange({ ...details, skillSet: allSkillIds });
      //    }else{
      //       console.log("Auto-selecting all skill IDs22:", allSkillIds);
      //       onChange({ ...details, skillSet: details.skillSet });
      //    }

      //    setAdditionalSkill(additionalSkillsOptions);
      //  }
    });
  }

  useEffect(() => {
    fetchHospitalDropdownData();
  }, []);

  useEffect(() => {
    if (details.hospital) {
      fetchDepartmentDropDown();
    }
    // fetchDepartmentDropDown();
  }, [details.hospital]);

  useEffect(() => {
    if (details.hospital && details.department) {
      fetchProfessionsDropDown();
    }
  }, [details.hospital, details.department]);

  useEffect(() => {
    if (details.hospital && details.department && details.profession) {
      fetchQualificationDropDown();
    }
  }, [details.hospital, details.department, details.profession]);

  useEffect(() => {
    if (
      details.hospital &&
      details.department &&
      details.profession &&
      details.qualification
    ) {
      fetchSpecializationDropDown();
    }
  }, [
    details.hospital,
    details.department,
    details.profession,
    details.qualification,
  ]);

  useEffect(() => {
    if (
      details.hospital &&
      details.department &&
      details.profession &&
      details.qualification &&
      details.specialization
    ) {
      fetchExperienceDropDown();
    }
  }, [
    details.hospital,
    details.department,
    details.profession,
    details.qualification,
    details.specialization,
  ]);

  console.log("details.department", details.department);
  console.log("details.profession", details.profession);

  useEffect(() => {
    if (
      details.department &&
      details.profession &&
      departmentTypeId.length > 0
    ) {
      fetchAdditionalSkillDropDown();
    }
  }, [details.department, details.profession, departmentTypeId.length > 0]);

  useEffect(() => {
    if (!details.department) {
      setAdditionalSkill([]);
    }
  }, [details.department]);

  const updateDetail = (key, value, experienceList = experiences) => {
    const newDetails = { ...details, [key]: value };
    const criticalKeys = [
      "hospital",
      "department",
      "profession",
      "qualification",
      "specialization",
      "experience",
    ];
    if (criticalKeys.includes(key)) {
      queryClient.removeQueries(["/api/shifts"]);
    }
    // console.log("here 3")
    // console.log("details", details);
    // if (details.skillSet) {
    //   newDetails.skillSet = details.skillSet;
    // }
    // console.log("newDetails", newDetails);

    // Reset dependent fields when parent changes
    if (key === "hospital") {
      newDetails.department = "";
      newDetails.profession = "";
      newDetails.qualification = "";
      newDetails.specialization = "";
      newDetails.skillSet = [];

      newDetails.additionalSkills = [];
      setAdditionalSkill([]);
      onChange({ ...newDetails });
      setDetailsData(newDetails);
      return;
      //  if (value === "") {
      //    setAdditionalSkill([]);
      //    onChange({
      //      ...newDetails,
      //      skillSet: [],
      //      additionalSkills: [],
      //    });
      //    setDetailsData(newDetails);
      //    return;
      //  }
    } else if (key === "department") {
      newDetails.profession = "";
      newDetails.qualification = "";
      newDetails.specialization = "";
      newDetails.skillSet = [];

      newDetails.additionalSkills = [];
      setAdditionalSkill([]);
      onChange({ ...newDetails });
      setDetailsData(newDetails);
      return;
      // if (value === "") {
      //   setAdditionalSkill([]);
      //   onChange({
      //     ...newDetails,
      //     skillSet: [],
      //     additionalSkills: [],
      //   });
      //   setDetailsData(newDetails);
      //   return;
      // }
    } else if (key === "profession") {
      newDetails.qualification = "";
      newDetails.specialization = "";
      // newDetails.skillSet = [];
    } else if (key === "qualification") {
      newDetails.specialization = "";
      newDetails.experience = "";
      // newDetails.skillSet = [];
    } else if (key === "specialization") {
      newDetails.experience = "";
      // newDetails.skillSet = [];
    }
    setDetailsData(newDetails);
    // console.log("newDetails2", newDetails);
    console.log("additionalSkills3", additionalSkills);
    const allSkillIds = additionalSkills.map((skill) => skill.id);
    const selectedHospital = hospitals?.find(
      (item) => item?.id?.toString() === newDetails?.hospital?.toString()
    );
    setCreditLimit(selectedHospital?.creditLimit);
    console.log("selectedHospital", selectedHospital);
    const selectedDepartment = departments?.find(
      (item) => item?.id?.toString() === newDetails?.department?.toString()
    );
    const selectedProfession = professions?.find(
      (item) => item?.id?.toString() === newDetails?.profession?.toString()
    );
    const selectedSpecialization = specializations?.find(
      (item) => item?.id?.toString() === newDetails?.specialization?.toString()
    );
    const selectedQualification = qualifications?.find(
      (item) => item?.id?.toString() === newDetails?.qualification?.toString()
    );
    const selectedExperience = experienceList?.find(
      (item) => item?.id?.toString() === newDetails?.experience?.toString()
    );

    console.log("allSkillIds2", allSkillIds);
    const updatedDetails = {
      ...(newDetails || {}),
      skillSet: allSkillIds,
      hospitalName: selectedHospital?.hospitalName || details.hospitalName,
      departmentName: selectedDepartment?.name || details.departmentName,
      professionName: selectedProfession?.name || details.professionName,
      specializationName:
        selectedSpecialization?.name || details.specializationName,
      qualificationName:
        selectedQualification?.name || details.qualificationName,
      experienceName: selectedExperience?.name || details.experienceName,
      creditLimit: selectedHospital?.creditLimit,
      utilizedLimit: selectedHospital?.utilizedLimit,
      isNewBranch: selectedHospital?.isNewBranch,
      creditThresholdPercent: selectedHospital?.creditThresholdPercent
    };
    console.log("Setting skillSet on updatedDetails:", updatedDetails);
    onChange(updatedDetails);
    // onChange(newDetails);
  };

  const toggleSkill = (skillId) => {
    const currentSkills = details.skillSet || [];
    const updatedSkills = currentSkills.includes(skillId)
      ? currentSkills.filter((id) => id !== skillId)
      : [...currentSkills, skillId];

    onChange({ ...details, skillSet: updatedSkills });
  };

  const removeSkill = (skillIdToRemove) => {
    const updatedSkills = (details.skillSet || []).filter(
      (id) => id !== skillIdToRemove
    );
    onChange({ ...details, skillSet: updatedSkills });
  };

  const addNewSkill = async () => {
    if (newSkill.trim() === "") return;

    let departmentData = departmentTypeId?.filter((data) => {
      return data?.id.toString() === details?.department?.toString();
    });
    const query = `
  mutation {
  mutationWithAuth(token: "${token}") {
    fabricate {
      createAdditionalSkill(
        name: "${newSkill}"
        department: "${departmentData[0]?.departmentType}"
        professionalType: "${details?.profession}"
      ) {
        id
        name
      }
    }
  }
}
    `;

    // console.log("query", query);
    try {
      const response = await graphqlRequest(query);
      const newSkillData =
        response?.data?.mutationWithAuth?.fabricate?.createAdditionalSkill;
      // console.log("New skill added:", response);
      if (newSkillData) {
        additionalSkills.push({
          id: newSkillData?.id,
          name: newSkillData?.name,
        });
        onChange({
          ...details,
          skillSet: [...(details.skillSet || []), newSkillData?.id],
        });
        setNewSkill("");
        setShowAddSkill(false);
      }
    } catch (error) {
      console.error("Error adding new skill:", error);
    }
    //  if (newSkill.trim() === "") return;
    //  const customSkillId = `custom-${Date.now()}`;
    //  additionalSkills.push({ id: customSkillId, name: newSkill });
    //  onChange({
    //    ...details,
    //    skillSet: [...(details.skillSet || []), customSkillId],
    //  });
    //  setNewSkill("");
    //  setShowAddSkill(false);
  };

  //  const handleKeyPress = (e) => {
  //    if (e.key === "Enter") {
  //      addNewSkill();
  //    }
  //  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmed = newSkill.trim();

      const isOnlyNumbers = /^[0-9]+$/.test(trimmed);
      const allowedPattern = /^[a-zA-Z0-9 &_\-./\\]+$/;
      const tooLongWord = trimmed.split(" ").find((word) => word.length > 75);
      const isTotalTooLong = trimmed.length > 75;

      if (
        !trimmed ||
        isOnlyNumbers ||
        !allowedPattern.test(trimmed) ||
        tooLongWord ||
        isTotalTooLong
      ) {
        setSkillError(
          !trimmed
            ? "Skill cannot be empty."
            : isOnlyNumbers
            ? "Only numbers are not allowed."
            : !allowedPattern.test(trimmed)
            ? "Only letters, numbers, &, /, \\, _, -, and . are allowed."
            : tooLongWord
            ? "No individual word should exceed 75 characters."
            : isTotalTooLong
            ? "Total skill length should not exceed 75 characters."
            : ""
        );
        return;
      }

      // ✅ Add if valid
      addNewSkill(trimmed);
      setNewSkill("");
      setSkillError("");
    }
  };

  const filteredSkills = additionalSkills?.filter((skill) =>
    skill.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSkillSetDropdownOpen(false); // 👈 Close dropdown
      }
    }

    if (skillSetDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [skillSetDropdownOpen]);

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     const trimmed = newSkill.trim();

  //     const isOnlyNumbers = /^[0-9]+$/.test(trimmed);
  //     const hasSpecialChars = /[^a-zA-Z0-9 ]/.test(trimmed);

  //     if (!trimmed || isOnlyNumbers || hasSpecialChars) {
  //       setSkillError(
  //         isOnlyNumbers
  //           ? "Only numbers are not allowed."
  //           : hasSpecialChars
  //           ? "Special characters are not allowed."
  //           : "Skill cannot be empty."
  //       );
  //       return; // ❌ Do not add
  //     }

  //     // ✅ Add if valid
  //     addNewSkill(trimmed);
  //     setNewSkill("");
  //     setSkillError("");
  //   }
  // };

  // console.log("hospitals>>", hospitals);
  // console.log("departments>>", departments);
  // console.log("professinals>>", professions);
  // console.log("additionalSkills", additionalSkills);
  // console.log("details", details);
  return (
    <div className="card-modern card-hover professional-details-form">
      <div className="p-6">
        <div className="component-header">
          <div className="icon-container">
            <ClipboardList size={20} />
          </div>
          <h2>Professional Details</h2>
        </div>

        <div className="grid grid-3">
          <div className="form-group">
            <label className="label">Branch</label>
            <select
              value={details.hospital}
              onChange={(e) => updateDetail("hospital", e.target.value)}
              className="select"
            >
              <option value="">Select branch</option>
              {hospitals?.map((hospital) => (
                <option key={hospital.id} value={hospital.id}>
                  {hospital.hospitalName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">Department</label>
            <select
              value={details.department}
              onChange={(e) => updateDetail("department", e.target.value)}
              disabled={!details.hospital}
              className="select"
            >
              <option value="">Select department</option>
              {departments?.map((department) => (
                <option key={department.id} value={department.id}>
                  {department.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">Profession</label>
            <select
              value={details.profession}
              onChange={(e) => updateDetail("profession", e.target.value)}
              disabled={!details.department}
              className="select"
            >
              <option value="">Select profession</option>
              {professions?.map((profession) => (
                <option key={profession.id} value={profession.id}>
                  {profession.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">Qualification</label>
            <select
              value={details.qualification}
              onChange={(e) => updateDetail("qualification", e.target.value)}
              disabled={!details.profession && !details.department}
              className="select"
            >
              <option value="">Select qualification</option>
              {qualifications?.map((qualification) => (
                <option key={qualification.id} value={qualification.id}>
                  {qualification.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">Specialization</label>
            <select
              value={details.specialization}
              onChange={(e) => updateDetail("specialization", e.target.value)}
              disabled={!details.qualification}
              className="select"
            >
              <option value="">Select specialization</option>
              {specializations?.map((specialization) => (
                <option key={specialization.id} value={specialization.id}>
                  {specialization.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">Experience</label>
            <select
              value={details.experience}
              onChange={(e) => updateDetail("experience", e.target.value)}
              disabled={!details.qualification || !details.specialization}
              className="select"
            >
              <option value="">Select experience</option>
              {experiences?.map((experience) => (
                <option key={experience.id} value={experience.id}>
                  {experience.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group skill-set-group">
            <label className="label">Additional Skills</label>
            <div className="skill-set-container">
              <div
                className="skill-set-input"
                // onClick={() => setSkillSetDropdownOpen(!skillSetDropdownOpen)}
                onClick={() => {
                  if (!details.hospital || !details.department) return;
                  setSkillSetDropdownOpen(!skillSetDropdownOpen);
                }}
              >
                {/* <div className="selected-skills">
                  {(details.skillSet || []).map((skill) => {
                    const skillId =
                      typeof skill === "object"
                        ? skill.id.toString()
                        : skill.toString();
                    const selectedSkill = additionalSkills.find(
                      (s) => s.id.toString() === skillId
                    );
                    return (
                      <span
                        key={skillId}
                        className="badge badge-primary skill-badge"
                      >
                        {selectedSkill?.name || "Unknown Skill"}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            removeSkill(skillId);
                          }}
                          className="skill-remove"
                        >
                          <X size={12} />
                        </button>
                      </span>
                    );
                  })}
                </div> */}
                <div className="selected-skills">
                  {(details.skillSet || []).map((skillId) => {
                    // console.log("skillId", skillId);
                    // console.log("additionalSkills22", additionalSkills);
                    const skill = additionalSkills?.find(
                      (s) => s?.id === skillId
                    );
                    // console.log("skill22", skill);
                    return (
                      <span
                        key={skillId}
                        className="badge badge-primary skill-badge"
                      >
                        {skill?.name || skillId?.name}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            removeSkill(skillId);
                          }}
                          className="skill-remove"
                        >
                          <X size={12} />
                        </button>
                      </span>
                    );
                  })}
                </div>
              </div>

              {skillSetDropdownOpen && (
                <div className="skill-dropdown" ref={dropdownRef}>
                  <div className="dropdown-header">
                    <button
                      className="close-dropdown-btn"
                      onClick={() => setSkillSetDropdownOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>
                  <input
                    type="text"
                    placeholder="Search skills..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="skill-search-input"
                  />
                  <div className="skill-options">
                    {filteredSkills.length > 0 ? (
                      filteredSkills.map((skill) => (
                        <label key={skill.id} className="skill-option">
                          <input
                            type="checkbox"
                            checked={(details.skillSet || []).includes(
                              skill.id
                            )}
                            onChange={() => toggleSkill(skill.id)}
                          />
                          <span>{skill.name}</span>
                        </label>
                      ))
                    ) : (
                      <p className="no-skills">No skills found</p>
                    )}
                  </div>

                  <div className="add-skill-section">
                    {!showAddSkill ? (
                      <button
                        onClick={() => setShowAddSkill(true)}
                        className="btn btn-secondary btn-sm add-skill-btn"
                        disabled={!details.hospital || !details.department}
                      >
                        <Plus size={14} />
                        Add New Skills
                      </button>
                    ) : (
                      <div className="add-skill-input">
                        <input
                          type="text"
                          value={newSkill}
                          // onChange={(e) => {
                          //   const value = e.target.value;
                          //   setNewSkill(value);

                          //   const trimmed = value.trim();
                          //   const isOnlyNumbers = /^[0-9]+$/.test(trimmed);
                          //   const hasSpecialChars = /[^a-zA-Z0-9 ]/.test(
                          //     trimmed
                          //   );

                          //   if (isOnlyNumbers) {
                          //     setSkillError("Only numbers are not allowed.");
                          //   } else if (hasSpecialChars) {
                          //     setSkillError(
                          //       "Special characters are not allowed."
                          //     );
                          //   } else {
                          //     setSkillError(""); // valid input
                          //   }
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setNewSkill(value);

                            const trimmed = value.trim();
                            const isOnlyNumbers = /^[0-9]+$/.test(trimmed);

                            // Allowed pattern: letters, numbers, space, &, /, \, _, -, .
                            const allowedPattern = /^[a-zA-Z0-9 &_\-./\\]+$/;

                            const tooLongWord = trimmed
                              .split(" ")
                              .find((word) => word.length > 75);
                            const isTotalTooLong = trimmed.length > 75;

                            if (isOnlyNumbers) {
                              setSkillError("Only numbers are not allowed.");
                            } else if (!allowedPattern.test(trimmed)) {
                              setSkillError(
                                "Only letters, numbers, &, /, \\, _, -, and . are allowed."
                              );
                            } else if (tooLongWord) {
                              setSkillError(
                                "No individual word should exceed 75 characters."
                              );
                            } else if (isTotalTooLong) {
                              setSkillError(
                                "Total skill length should not exceed 75 characters."
                              );
                            } else {
                              setSkillError(""); // ✅ Valid input
                            }
                          }}
                          onKeyPress={handleKeyPress}
                          placeholder="Enter custom skill"
                          className="input"
                        />
                        {skillError && (
                          <p
                            className="error-message"
                            style={{ color: "red", fontSize: "0.85rem" }}
                          >
                            {skillError}
                          </p>
                        )}

                        <div className="add-skill-actions">
                          <button
                            onClick={addNewSkill}
                            className="btn btn-primary btn-sm"
                            disabled={!!skillError || !newSkill.trim()}
                          >
                            Add
                          </button>
                          <button
                            onClick={() => {
                              setShowAddSkill(false);
                              setNewSkill("");
                              setSkillError("");
                            }}
                            className="btn btn-secondary btn-sm"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalDetailsForm;
